import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appMaxLengthInput]',
  standalone: true,
})
export class MaxLengthInputDirective {
  @Input() appMaxLengthInput: number | undefined;
  
  constructor(private el: ElementRef, private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    const inputValue = this.el.nativeElement.value;
    const maxLength = this.appMaxLengthInput;

    if (maxLength && inputValue.length >= maxLength) {
      this.el.nativeElement.value = inputValue.substring(0, maxLength);
      event.preventDefault();
    }

  }
}
